import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

export const NoMessagesView: FC = () => (
  <Col gridGap="S400" width="100%">
    <Row>
      <Text>{getString("orderMessages.noMessagesTitle")}</Text>
    </Row>
    <Row>
      <Text>{getString("orderMessages.noMessagesText")}</Text>
    </Row>
  </Col>
);
